export const Api = 'api';
export const SelloApi = 'selloApi';
export const Suz = 'suz';
export const NotHandle5xx = 'not-handle-5xx';
export const NotHandle404 = 'not-handle-404';
export const OmitMessage = 'omit-message';
